import { NotifyHelper } from "../../../helpers/toast";
import { eDanhSachKhongDuDieuKienThucTapActionsObj } from "../../action-types/xet-thuc-tap/IDanhSachKhongDuDieuKienThucTapActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const danhSachKhongDuDieuKienThucTapActions = {
    ...generateActions(eDanhSachKhongDuDieuKienThucTapActionsObj, "DANH_SACH_KHONG_DU_DIEU_KIEN_THUC_TAP"),
    ...generateActionForKey(eDanhSachKhongDuDieuKienThucTapActionsObj, "DANH_SACH_KHONG_DU_DIEU_KIEN_THUC_TAP", "LOAD_BY_DOT_THUC_TAP_ERROR", (message) => {
        NotifyHelper.Error(message);
    }),
    ...generateActionForKey(eDanhSachKhongDuDieuKienThucTapActionsObj, "DANH_SACH_KHONG_DU_DIEU_KIEN_THUC_TAP", "LOAD_BY_DOT_THUC_TAP_CHI_TIET_DIEM_ERROR", (message) => {
        NotifyHelper.Error(message);
    }),
    ...generateActionForKey(eDanhSachKhongDuDieuKienThucTapActionsObj, "DANH_SACH_KHONG_DU_DIEU_KIEN_THUC_TAP", "CHUYEN_DU_DIEU_KIEN_SUCCESS", () => {
        NotifyHelper.Success("Đã chuyển sinh viên sang đủ điều kiện thực tập");
    }),
    ...generateActionForKey(eDanhSachKhongDuDieuKienThucTapActionsObj, "DANH_SACH_KHONG_DU_DIEU_KIEN_THUC_TAP", "CHUYEN_DU_DIEU_KIEN_ERROR", (message) => {
        NotifyHelper.Error(message);
    }),
}